import { useContext } from 'react';
import { Panel } from '../../../../layouts';
import { ROType } from '../../../../types/enums';
import { RetailOrderContext } from '../context/RetailOrderContext';
import RetailOrderCabinetDates from './RetailOrderCabinetDates';
import RetailOrderCountertopDatesPanel from './RetailOrderCountertopDates';
import RetailOrderPlumbingDates from './RetailOrderPlumbingDates';

export default function RetailOrderDatesPanel(props: {
	showScheduledInstallDates?: boolean,
	showActualInstallDates?: boolean,
	showInvoiceDate?: boolean,
	editCabinetDates?: boolean,
	showChangeOrderCallScript?: boolean
}) {

	const { order } = useContext(RetailOrderContext);

	const isCabinetOrder = order.details.roTypeID === ROType.CabinetInstallOrder || order.details.roTypeID === ROType.CabinetMeasureOrder;
	const isPlumbingOrder = order.details.roTypeID === ROType.Plumbing;
	const isCountertopOrder = !isCabinetOrder && !isPlumbingOrder;

	return (
		<Panel header={'Dates'}>
			{
				isCountertopOrder &&
				<RetailOrderCountertopDatesPanel
					{...props}
				/>
			}
			{
				isCabinetOrder &&
				<RetailOrderCabinetDates
					{...props}
				/>
			}
			{
				isPlumbingOrder &&
				<RetailOrderPlumbingDates />
			}
		</Panel>
	);
}
